// Genuine product data sourced from manufacturer official sites.
// Images are direct CDN URLs from manufacturer official sites — no dummy/placeholder images.
// Sources: cochlear.com (India), medel.com, advancedbionics.com

export const MANUFACTURERS = [
  {
    id: "cochlear",
    name: "Cochlear Limited",
    country: "Australia",
    website: "https://www.cochlear.com/in/en/home",
    indiaWebsite: "https://www.cochlear.com/in/en/home",
    tagline: "Hear now. And always.",
    description:
      "Cochlear Limited is the global leader in implantable hearing solutions. The Nucleus System is its flagship cochlear implant family, with the Nucleus 8 sound processor and the new Nucleus Nexa System as the latest generation.",
    logoText: "Cochlear",
    colorAccent: "#FFD200",
  },
  {
    id: "medel",
    name: "MED-EL",
    country: "Austria",
    website: "https://www.medel.com",
    indiaWebsite: "https://www.medel.com/in",
    tagline: "Closest to natural hearing.",
    description:
      "MED-EL is an Austrian hearing implant company with a strong focus on electrode design and natural sound coding. The SYNCHRONY 2 implant is paired with the SONNET 3 (behind-the-ear) and RONDO 3 (off-the-ear) audio processors.",
    logoText: "MED-EL",
    colorAccent: "#E2231A",
  },
  {
    id: "ab",
    name: "Advanced Bionics",
    country: "USA (Sonova Group)",
    website: "https://www.advancedbionics.com",
    indiaWebsite: "https://www.advancedbionics.com",
    tagline: "Hear your best, every day.",
    description:
      "Advanced Bionics (an AB - Sonova brand) makes the HiRes Ultra 3D implant paired with the Naída CI Marvel (adults) and Sky CI M (children) sound processors, with universal Bluetooth connectivity and Phonak Marvel technology.",
    logoText: "Advanced Bionics",
    colorAccent: "#E94E1B",
  },
];

export const PRODUCTS = [
  // -------- COCHLEAR --------
  {
    id: "nucleus-8",
    manufacturer: "cochlear",
    name: "Cochlear Nucleus 8 Sound Processor",
    short: "Smaller. Smarter. Better connected.",
    category: "Sound Processor (Behind-the-Ear)",
    image:
      "https://assets.cochlear.com/api/public/content/5658cc69cfa64300b0e9d2df78f72de8?v=6d762606",
    gallery: [
      "https://assets.cochlear.com/api/public/content/3bb36f67b7734ee98711eaf4a0d855b0?v=dedcebe5",
      "https://assets.cochlear.com/api/public/content/be9f0189029249b59dbaaf03d8e26b81?v=6bdb2b4c",
      "https://assets.cochlear.com/api/public/content/c2bffbfdf8044a09abdc001e9eeddaa6?v=f0a014dd",
      "https://assets.cochlear.com/api/public/content/626cae3ac16d413e820ed32fe94ea729?v=2089a0f6",
      "https://assets.cochlear.com/api/public/content/87ae03de1a9c4c31aadbd16650c00a16?v=cc66ca2d",
      "https://assets.cochlear.com/api/public/content/ba0e7091d0604106b80bf10e6cc74335?v=fec49820",
    ],
    description:
      "The world's smallest and lightest behind-the-ear cochlear implant sound processor. Designed to help adults and children hear clearly with SmartSound® iQ 2 and SCAN 2 hearing technology that automatically adjusts to the environment.",
    keyFeatures: [
      "15% smaller and 13% lighter than Nucleus 7",
      "SmartSound® iQ 2 with SCAN 2 — auto environment adjustment",
      "Ready for Bluetooth® LE Audio and Auracast™ broadcast",
      "Direct streaming from compatible Apple & Android devices",
      "Six colour options for personal style",
      "Optional Aqua+ accessory for water-safe use (IP68)",
      "Nucleus Smart App — monitor, manage and control",
    ],
    audience: ["adult", "child"],
    source: "https://www.cochlear.com/in/en/home/products-and-accessories/cochlear-nucleus-system/nucleus-sound-processors/nucleus-8",
    sourceLabel: "Cochlear India — Nucleus 8 product page",
  },
  // -------- MED-EL --------
  {
    id: "synchrony-2",
    manufacturer: "medel",
    name: "MED-EL SYNCHRONY 2 Cochlear Implant",
    short: "Closest to natural hearing. MRI up to 3.0T without magnet removal.",
    category: "Cochlear Implant (Internal)",
    image:
      "https://sfc01.cdn.medel.com/images/default-source/product-images/synchrony-2/synchrony-2.png?auto=format&sfvrsn=fdfefd41_1",
    gallery: [
      "https://sfc01.cdn.medel.com/images/default-source/product-images/synchrony-2/synchrony-2_front.png?auto=format&sfvrsn=eb05c641_1",
      "https://sfc01.cdn.medel.com/images/default-source/product-images/synchrony-2/synchrony-2-front.png?auto=format&sfvrsn=4ffbfd41_1",
      "https://sfc02.cdn.medel.com/images/librariesprovider3/hearing-implants/cochlear-implants/synchrony-2/banner_1.jpg?auto=format&sfvrsn=5dfdfd41_3",
    ],
    description:
      "SYNCHRONY 2 is MED-EL's flagship cochlear implant — designed for optimal sound quality, simple surgery and outstanding MRI safety. Compatible with all current MED-EL audio processors (SONNET 3 and RONDO 3).",
    keyFeatures: [
      "MRI safe up to 3.0 Tesla without magnet removal",
      "Removable S-Vector self-aligning magnet",
      "Wide range of electrode arrays (FLEX, FORM, CLASSIC series)",
      "Up to 50,704 pulses/second stimulation rate",
      "Hermetic titanium housing — impact resistant ≥ 2.5 Joule",
      "Lifetime MRI guarantee from MED-EL",
    ],
    audience: ["adult", "child"],
    source: "https://www.medel.com/hearing-solutions/cochlear-implants/synchrony2",
    sourceLabel: "MED-EL — SYNCHRONY 2 product page",
  },
  {
    id: "sonnet-3",
    manufacturer: "medel",
    name: "MED-EL SONNET 3 Audio Processor",
    short: "Comfortable, waterproof, direct streaming behind-the-ear.",
    category: "Sound Processor (Behind-the-Ear)",
    image:
      "https://sfc01.cdn.medel.com/images/default-source/product-images/sonnet-3/sonnet-3352845c2-94b6-45fe-902d-506138abd500-2-rcb.png?auto=format&sfvrsn=86478e40_6",
    gallery: [
      "https://sfc01.cdn.medel.com/images/default-source/product-images/sonnet-3/sonnet3_div_img-rcb.jpg?auto=format&sfvrsn=e5478e40_7",
    ],
    description:
      "SONNET 3 offers an ergonomic behind-the-ear design, integrated direct streaming and waterproof construction — for freedom, flexibility and closest to natural hearing.",
    keyFeatures: [
      "Integrated direct streaming (no extra accessories)",
      "Waterproof behind-the-ear design",
      "Comfortable, ergonomic shape",
      "Compatible with SYNCHRONY and SYNCHRONY 2",
    ],
    audience: ["adult", "child"],
    source: "https://www.medel.com/hearing-solutions/cochlear-implants/sonnet3",
    sourceLabel: "MED-EL — SONNET 3 product page",
  },
  {
    id: "rondo-3",
    manufacturer: "medel",
    name: "MED-EL RONDO 3 Audio Processor",
    short: "Off-the-ear, single-unit processor with wireless charging.",
    category: "Sound Processor (Off-the-Ear)",
    image:
      "https://sfc02.cdn.medel.com/images/default-source/product-related/rondo-3/ro3-processor-noshadow-3col.jpg?auto=format&sfvrsn=6e8dc342_0",
    gallery: [
      "https://sfc02.cdn.medel.com/images/librariesprovider3/hearing-implants/cochlear-implants/rondo3/ro3-processor-navi-2col_size-adaption.jpg?auto=format&sfvrsn=328fc342_0",
    ],
    description:
      "RONDO 3 is a single-unit off-the-ear audio processor — making hearing incredibly simple with wireless streaming and wireless charging.",
    keyFeatures: [
      "Single-unit off-the-ear design",
      "Wireless charging",
      "Wireless streaming",
      "Compatible with SYNCHRONY and SYNCHRONY 2",
    ],
    audience: ["adult", "child"],
    source: "https://www.medel.com/hearing-solutions/cochlear-implants/rondo3",
    sourceLabel: "MED-EL — RONDO 3 product page",
  },
  // -------- ADVANCED BIONICS --------
  {
    id: "naida-ci-m",
    manufacturer: "ab",
    name: "Advanced Bionics Naída CI Marvel",
    short: "Powerful, connected adult cochlear implant sound processor.",
    category: "Sound Processor (Behind-the-Ear, Adults)",
    image:
      "https://www.advancedbionics.com/content/advancedbionics/com/en/home/explore/processors-and-cochlear-implants/naida-ci-m/_jcr_content/root/container/container/container_1900460481/container/container_copy/image_copy.coreimg.png/1779839110601/product-naida-ci-marvel-uhp-velvet-black.png",
    gallery: [
      "https://www.advancedbionics.com/content/advancedbionics/com/en/home/explore/processors-and-cochlear-implants/naida-ci-m/_jcr_content/root/container/container/container_1193488073/container/container_714928792_/image.coreimg.png/1779839112039/product-naida-ci-m-with-hp-silver.png",
    ],
    description:
      "The Naída CI Marvel is a user-friendly, powerful cochlear implant sound processor designed for adults. It works with the HiRes Ultra 3D implant to provide universal Bluetooth connectivity, AutoSense OS 3.0 environment adaptation, and seamless linked two-ear hearing with Phonak.",
    keyFeatures: [
      "AutoSense OS 3.0 — automatic environment adjustment",
      "Universal Bluetooth® connectivity",
      "Hands-free phone calls and audio streaming",
      "Linked two-ear solutions with Phonak hearing aids",
      "Remote programming via AB Remote Support app",
      "Waterproof, durable design",
    ],
    audience: ["adult"],
    source: "https://www.advancedbionics.com/com/en/home/explore/processors-and-cochlear-implants/naida-ci-m",
    sourceLabel: "Advanced Bionics — Naída CI Marvel page",
  },
  {
    id: "sky-ci-m",
    manufacturer: "ab",
    name: "Advanced Bionics Sky CI M",
    short: "The world's first cochlear implant sound processor designed for children.",
    category: "Sound Processor (Behind-the-Ear, Children)",
    image:
      "https://www.advancedbionics.com/content/advancedbionics/com/en/home/explore/processors-and-cochlear-implants/sky-ci-m/_jcr_content/root/container/container/container_copy/container_1476857859/image.coreimg.png/1725053346096/product-sky-ci-uhp-caribbean-pirate.png",
    gallery: [],
    description:
      "Sky CI M is the world's first dedicated children's cochlear implant sound processor — combining AB and Phonak Sky technology for powerful hearing, flexibility for active children, and linked two-ear solutions.",
    keyFeatures: [
      "AutoSense Sky OS 3.0 — kids-specific environment adaptation",
      "Universal Bluetooth® connectivity for devices and games",
      "Built-in Roger receiver for classroom listening",
      "Waterproof battery + Slim HP AquaMic™ for active children",
      "Linked two-ear solutions with Phonak Sky",
      "Multiple wearing options for growing children",
    ],
    audience: ["child"],
    source: "https://www.advancedbionics.com/com/en/home/explore/processors-and-cochlear-implants/sky-ci-m",
    sourceLabel: "Advanced Bionics — Sky CI M page",
  },
];

export const HOW_CI_WORKS_DIAGRAM =
  "https://www.advancedbionics.com/content/advancedbionics/com/en/home/explore/processors-and-cochlear-implants/naida-ci-m/_jcr_content/root/container/container/container_copy/container/image_copy.coreimg.jpeg/1779839113069/diagram-how-a-ci-works-5.jpeg";
